
export default {
  formattedExtensions (extensions: Array<string>): string {
    return extensions.map(extension => {
      return extension.split('/')[1]
    }).join().replace(/,/g, ', ')
  }
}
